import {IPaymentArticles, IPaymentArticlesListItem, PaymentArticlesResponseType} from "@/entity/finance/payment_articles/paymentArticles.types";

export default class PaymentArticles implements IPaymentArticles {
    total: number;
    data: IPaymentArticlesListItem[] = [];
    constructor(data: PaymentArticlesResponseType) {
        this.total = data.total;
        for (let i = 0; i < data.data.length; i++) {
            this.data.push(data.data[i]);
        }
    }
}